import { useMemo } from "react";
import {
  Paper,
  Typography,
  Box,
} from "@mui/material";
import WGRTable from "./c6Table";


//import WGRTotals from "./iohTotals";

export default function WGRShopGroup({
  shop,
  rows,
}) {
  /*
   * Shop Total
   */
   const totals = useMemo(() => {




    return rows.reduce(
      (total, row) => ({
        debit:
          total.debit +
          Number(row.DEBIT || 0),

        credit:
          total.credit +
          Number(row.CREDIT || 0),

                 

         }),

        
          

      {
        debit: 0,
        credit: 0,
        
      }
    );
  }, [rows]);

  return (
    <Paper
      elevation={2}
      sx={{
        overflow: "hidden",
        borderRadius: 2,
      }}
    >
      {/* Shop Header */}

      {/* <Box
        sx={{
          bgcolor: "primary.main",
          color: "white",
          px: 2,
          py: 1,
          mt:5,
          minHeight:20,
        }}
      >
        <Typography
          variant="h6"
          fontWeight={700}
        >
          Railway  : {shop}
        </Typography>
      </Box> */}

      {/* Detail Table */}

     

      {/* Shop Total */}
 {/* THIS IS WHERE WGRTable SHOULD BE */}
   <WGRTable
  rows={rows}
  shop={shop}
  totals={totals}
  showTotal={true}
/>
      
        
    </Paper>
  );
}

